/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type SwapOfferAcceptMutationVariables = Types.Exact<{
	input: Types.SwapOfferAcceptRequest;
}>;

export type SwapOfferAcceptMutation = {
	__typename?: "Mutation";
	swapOfferAccept:
		| {
				__typename?: "SwapOfferAcceptSuccessResponse";
				swapOffer: {
					__typename?: "SwapOfferAccept";
					isTaxable: boolean;
					sourceTrade: {
						__typename?: "SwapOfferAcceptTrade";
						tradeId: string;
						assetId: string;
						assetWallet: { __typename?: "Wallet"; id: string };
						fiatWallet: { __typename?: "Wallet"; id: string };
						fiatWalletTransaction: { __typename?: "FiatWalletTransaction"; id: string };
						amountAsset: { __typename?: "CurrencyAmount"; value: string };
						feePercentage: { __typename?: "FeePercentage"; value: string };
						executionTime: { __typename?: "DateTime"; iso8601: string };
					};
					targetTrade: {
						__typename?: "SwapOfferAcceptTrade";
						tradeId: string;
						assetId: string;
						assetWallet: { __typename?: "Wallet"; id: string };
						fiatWallet: { __typename?: "Wallet"; id: string };
						fiatWalletTransaction: { __typename?: "FiatWalletTransaction"; id: string };
						amountAsset: { __typename?: "CurrencyAmount"; value: string };
						feePercentage: { __typename?: "FeePercentage"; value: string };
						executionTime: { __typename?: "DateTime"; iso8601: string };
					};
					taxWithheld?: {
						__typename?: "Tax";
						isTaxServiceAvailable: boolean;
						fiatId: string;
						assetId?: string | null;
						taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
						fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
						taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
					} | null;
				};
		  }
		| {
				__typename?: "SwapOfferInProgressResponse";
				swapOffersInProgress: { __typename?: "SwapOfferInProgress"; swapOfferId: string };
		  };
};

export const SwapOfferAcceptDocument = gql`
	mutation swapOfferAccept($input: SwapOfferAcceptRequest!) {
		swapOfferAccept(request: $input) {
			... on SwapOfferAcceptSuccessResponse {
				swapOffer {
					sourceTrade {
						tradeId
						assetId
						assetWallet {
							id
						}
						fiatWallet {
							id
						}
						fiatWalletTransaction {
							id
						}
						amountAsset {
							value
						}
						feePercentage {
							value
						}
						executionTime {
							iso8601
						}
					}
					targetTrade {
						tradeId
						assetId
						assetWallet {
							id
						}
						fiatWallet {
							id
						}
						fiatWalletTransaction {
							id
						}
						amountAsset {
							value
						}
						feePercentage {
							value
						}
						executionTime {
							iso8601
						}
					}
					taxWithheld {
						taxAmountFiat {
							value
						}
						isTaxServiceAvailable
						fiatId
						assetId
						fiatAmountAfterTax {
							value
						}
						taxAmountAsset {
							value
						}
					}
					isTaxable
				}
			}
			... on SwapOfferInProgressResponse {
				swapOffersInProgress {
					swapOfferId
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class SwapOfferAcceptGQLService extends Apollo.Mutation<
	SwapOfferAcceptMutation,
	SwapOfferAcceptMutationVariables
> {
	document = SwapOfferAcceptDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
